<template>
  <div id="app">
    <v-app>
      <v-content>
        <router-view></router-view>
      </v-content>
    </v-app>
  </div>
</template>

<script>
export default {
  name: 'app'
}
</script>

<style>
  @import url('https://fonts.googleapis.com/css?family=Roboto');
  body{
    margin: 0;
    font-family: 'Roboto', sans-serif;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue